import { styled } from '@mui/material';
import { Box } from '@mui/system';
export const BluredMap = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'blur',
})(({ theme, blur }) => ({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    flexGrow: 1,
    height: '100%',
    width: '100%',
    position: 'relative',
    filter: blur ? 'blur(3px)' : 'none',
    pointerEvents: blur ? 'none' : 'auto',
}));
